export const panelTheme = {
  colorScheme: {
    light: {
      root: {
        background: 'transparent',
        borderColor: 'transparent',
        borderRadius: '8px',
        color: '{gray.900}'
      },
      header: {
        background: 'transparent',
        color: '{gray.900}',
        padding: '0 16px',
        borderColor: 'var(--bs-border-color)',
        borderWidth: '0 0 1px 0',
        borderRadius: '0'
      },
      title: {
        fontWeight: '600'
      },
      content: {
        background: 'transparent',
        padding: '16px'
      },
      footer: {
        background: 'transparent',
        padding: '0 16px 16px 16px'
      }
    },
    dark: {
      root: {
        background: 'transparent',
        borderColor: 'transparent',
        borderRadius: '8px',
        color: '{gray.0}'
      },
      header: {
        background: 'transparent',
        color: '{gray.0}',
        padding: '0 16px',
        borderColor: 'var(--bs-border-color)',
        borderWidth: '0 0 1px 0',
        borderRadius: '0'
      },
      title: {
        fontWeight: '600'
      },
      content: {
        background: 'transparent',
        padding: '16px'
      },
      footer: {
        background: 'transparent',
        padding: '0 16px 16px 16px'
      }
    }
  }
};
